<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red accent-4"
                class="white--text"
                @click="confirmDialog = false"
                >{{ this.messageDismissButton }}</v-btn
              >
              <v-btn
                v-if="showConfirmButton"
                color="red accent-4"
                class="white--text"
                @click="deleteFromDatabase"
                >{{ this.messageConfirmButton }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <merus-data-table
      :headers="headers"
      :items="empresas"
      :mostrar-inativos="mostrarInativos"
      :default-multi-sort="defaultMultiSort"
      @update:displayedItems="displayedItemsForExport = $event"
    

 cod-tabela="EMPRESAS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar 
          :title="$t('company.title')" 
          :token="token" 
          :items="displayedItemsForExport !== null ? displayedItemsForExport : empresasFiltradas"
          :csv-title="$tc('company.self', 2)"
          :pdf-title="$tc('company.self', 2)"
          :pdf-headers="headers"
          pdf-filename="empresas"
          :csv-headers="headersCSV"
          csv-filename="empresas"
          :help-dialog-csv-fields="helpCSV"
          :help-dialog-csv-model="$tc('company.self', 2)"
          :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvempresas/' : null"
          @saveBulk="saveBulk"
          hide-search
        >
          <template v-slot:extension>
            <v-switch
              v-model="mostrarInativos"
              :label="$t('crudVeiculos.showInactive')"
              class="ml-3 mr-4"
              hide-details
            ></v-switch>
          </template>
        <template v-slot:add v-if="canInsert">
          <v-dialog v-model="dialog" max-width="100%">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline" style="color: #4a4a4a">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-form ref="form" v-model="formValidado">
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.cnpj" :label="$t('company.headers.cnpj')"
                          v-mask="'##.###.###/####-##'" :rules="[cnpjRules]"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="8">
                        <v-text-field v-model="editedItem.razao_social"
                          :label="$t('company.headers.razaoSocial') + ' *'" :counter="100"
                          :rules="razaoSocialRules"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="4" md="7">
                        <v-select v-model="editedItem.id_empresa_matriz" :items="matriz" item-text="razao_social"
                          item-value="id_empresa" single-line auto :label="$t('form.parentOptional')">
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="4" md="3">
                        <v-text-field v-model="editedItem.cod_integracao" :label="$t('company.headers.integrationCode')">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-switch v-model="editedItem.ativa" :label="$t('company.headers.active')">
                        </v-switch>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-combobox
                          v-model="locaisSelecionados"
                          :items="locaisDoEmpresa"
                          :label="$t('company.headers.locations')"
                          item-text="nome_local"
                          item-value="id_local"
                          multiple
                          chips
                          small-chips
                          deletable-chips
                          clearable
                          :placeholder="$t('company.locationsPlaceholder')"
                          hide-selected
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index < 8" small close @click:close="removeLocal(index)">
                              {{ getNomeLocal(item) }}
                            </v-chip>
                            <span v-else-if="index === 8" class="grey--text text-caption">
                              (+{{ locaisSelecionados.length - 8 }} {{ $t('company.locationsMore') }})
                            </span>
                          </template>
                        </v-combobox>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" class="white--text" @click="close">{{ $t('button.cancel') }}</v-btn>
                <v-btn color="primary darken-1" class="white--text" @click="save">{{ $t('button.save') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>

        </CadastroToolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="item.ativa === 0 || !canDelete">mdi-delete</v-icon>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import axios from "axios";
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import registrarChamadaApiExterna from "@/utils/registrarChamadaApiExterna";
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';

export default {
  components: {
    MerusDataTable,
    CadastroToolbar
},
  data: () => ({
    search: "",
    mostrarInativos: false,
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    messageConfirmButton: "",
    messageDismissButton: "",
    uf: [
      { id: "AC", nome: "ACRE" },
      { id: "AL", nome: "ALAGOAS" },
      { id: "AP", nome: "AMAPÁ" },
      { id: "AM", nome: "AMAZONAS" },
      { id: "BA", nome: "BAHIA" },
      { id: "CE", nome: "CEARÁ" },
      { id: "DF", nome: "DISTRITO FEDERAL" },
      { id: "ES", nome: "ESPÍRITO SANTO" },
      { id: "GO", nome: "GOIÁS" },
      { id: "MA", nome: "MARANHÃO" },
      { id: "MT", nome: "MATO GROSSO" },
      { id: "MS", nome: "MATO GROSSO DO SUL" },
      { id: "MG", nome: "MINAS GERAIS" },
      { id: "PA", nome: "PARÁ" },
      { id: "PB", nome: "PARAÍBA" },
      { id: "PR", nome: "PARANÁ" },
      { id: "PE", nome: "PERNAMBUCO" },
      { id: "PI", nome: "PIAUÍ" },
      { id: "RJ", nome: "RIO DE JANEIRO" },
      { id: "RN", nome: "RIO GRANDE DO NORTE" },
      { id: "RS", nome: "RIO GRANDE DO SUL" },
      { id: "RO", nome: "RONDÔNIA" },
      { id: "RR", nome: "RORAIMA" },
      { id: "SC", nome: "SANTA CATARINA" },
      { id: "SP", nome: "SÃO PAULO" },
      { id: "SE", nome: "SERGIPE" },
      { id: "TO", nome: "TOCATINS" }],
    empresas: [],
    displayedItemsForExport: null,
    matriz: [],
    editedIndex: -1,
    editedItem: {
      id_empresa: null,
      cnpj: null,
      razao_social: null,
      id_empresa_matriz: null,
      razao_social_matriz: null,
      ativa: null,
      ativa_extenso: null,
      cod_integracao: null,
    },
    deletedItem: {
      id_empresa: null,
      cnpj: null,
      razao_social: null,
      id_empresa_matriz: null,
      razao_social_matriz: null,
      ativa: null,
      ativa_extenso: null,
      cod_integracao: null,
    },
    defaultItem: {
      id_empresa: null,
      cnpj: null,
      razao_social: null,
      id_empresa_matriz: null,
      razao_social_matriz: null,
      ativa: null,
      ativa_extenso: null,
      cod_integracao: null,
    },
    locaisDoEmpresa: [],
    locaisSelecionados: [],
    recursos: [],
    permissoes: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
    headers: [],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? this.$t('formTitle.create') : this.$t('formTitle.edit');
    },
    cepRules() {
      return [
        (v) => !!v || this.$t('address.postalCode') + " " + this.$t('validation.required'),
        (v) => /^[0-9]{5}-[0-9]{3}$/.test(v) || /^[0-9]{5}-[0-9]{3}$/.test(v) || this.$t('validation.invalidFormat')];
    },
    razaoSocialRules() {
      return [(v) => !!v || this.$t('company.headers.razaoSocial') + " " + this.$t('validation.requiredFeminine')
      ];
    },
    numeroRules() {
      return [(v) => !!v || this.$t('address.number') + " " + this.$t('validation.required')];
    },
    headersCSV() {
      return [
        { text: this.$t('company.csvHeaders.lineNumber'), value: "line_number", error: "error_line" },
        { text: this.$t('company.csvHeaders.operation'), value: "operacao" },
        { text: this.$t('company.headers.integrationCode'), value: "cod_integracao" },
        { text: this.$t('company.headers.cnpj'), value: "cnpj" },
        { text: this.$t('company.headers.razaoSocial'), value: "razao_social" },
        { text: this.$t('company.headers.idParentCompany'), value: "id_empresa_matriz", align: " d-none" },
        { text: this.$t('company.headers.parentCompanyName'), value: "razao_social_matriz" },
        { text: this.$t('company.headers.active'), value: "ativa_extenso" }];
    },
    defaultMultiSort() {
      return [
        { value: 'ativa_extenso', options: { text: this.$t('routs.decreasing'), value: -1 } },
        { value: 'razao_social', options: { text: this.$t('routs.increasing'), value: 1 } }];
    },
    helpCSV() {
      return [
        {
          label: this.$t('company.headers.integrationCode'),
          description: this.$t('company.headers.integrationCodeDescription'),
          example: this.$t('company.headers.integrationCodeExample'),
          key: "cod_integracao"
        },
        {
          label: this.$t('company.headers.razaoSocial'),
          description: this.$t('company.headers.razaoSocialDescription'),
          example: this.$t('company.headers.razaoSocialExample'),
          key: "razao_social"
        },
        {
          label: this.$t('company.headers.cnpj'),
          description: this.$t('company.headers.cnpjDescription'),
          example: this.$t('company.headers.cnpjExample'),
          key: "cnpj"
        },
        {
          label: this.$t('company.headers.active'),
          description: this.$t('company.headers.activeDescription'),
          example: this.$t('company.headers.activeExample'),
          key: "ativa"
        },
        {
          label: this.$t('company.headers.parentCompanyCode'),
          description: this.$t('company.headers.parentCompanyCodeDescription'),
          example: this.$t('company.headers.parentCompanyCodeExample'),
          key: "cod_empresa_matriz"
        }];
    },
    cnpjRules() {
      if (this.editedItem.cnpj == null) {
        return true;
      } else {
        if (this.editedItem.cnpj.length === 0) {
          return this.$t("validation.cnpjRequired");
        } else {
          if (
            !/^[0-9]{2}.[0-9]{3}.[0-9]{3}\/[0-9]{4}.[0-9]{2}$/.test(this.editedItem.cnpj)
          ) {
            return this.$t("validation.cnpjInvalidFormat");
          } else {
            if (!this.validaCNPJ(this.editedItem.cnpj)) {
              return this.$t("validation.cnpjInvalid");
            } else {
              return true;
            }
          }
        }
      }
    },
    empresasFiltradas() {
      if (!this.mostrarInativos) {
        return this.empresas.filter((empresa) => {
          return empresa.ativa === true || empresa.ativa === 1;
        });
      }
      return this.empresas;
    },
  },
  watch: {
    dialog(val) {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      if (val && this.editedIndex === -1) {
        this.locaisDoEmpresa = [];
        this.locaisSelecionados = [];
      }
      val || this.close();
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  mounted() {
    this.$root.$emit("eventshowback", true);
  },
  methods: {

    initialize() {
      this.populaPermissoes();
      this.populaRecursos();
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        },
      });
        this.populaMatriz();
    },
    populaPermissoes() {
      apiController.request(apiController.endpoints.getPermissoesusuario, {
        params: { id: this.user.id_usuario },
        onSuccess: (response) => {
          this.permissoes = response.data;
        },
      });
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.populaEmpresas();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updateempresa");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertempresa");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleteempresa");
            this.populaEmpresas();
          },
        });
      }
    },
    populaMatriz() {
      apiController.request(apiController.endpoints.getEmpresasmatriz, {
        onSuccess: (response) => {
          this.matriz = response.data;
        },
      });
    },
    buscaCEP() {
      const ceptemp = String(this.editedItem.cep || '').replace(/\D/g, '');
      if (ceptemp.length !== 8) return;
      registrarChamadaApiExterna('VIACEP', 'CEP_LOOKUP', 1, this.token);
      axios
        .get("https://viacep.com.br/ws/" + ceptemp + "/json/")
        .then((response) => {
          if (response.data.erro == true) {
            this.mensagemdialog = this.$t('validation.cepNotFound');
            this.showConfirmButton = false;
            this.messageDismissButton = this.$t('button.confirmOk');
            this.confirmDialog = true;
          } else {
            this.editedItem.logradouro = response.data.logradouro;
            this.editedItem.bairro = response.data.bairro;
            this.editedItem.cidade = response.data.localidade;
            this.editedItem.uf = response.data.uf;
          }
        })
        .catch((e) => {
          EventBus.$emit('show-error', { error: e });
        });
    },
    editItem(item) {
      this.editedIndex = this.empresas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.loadLocaisDoEmpresa(item.id_empresa);
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = this.$t('dialog.confirmDelete', { company: item.razao_social });
      this.showConfirmButton = true;
      this.messageDismissButton = this.$t('button.dismiss');
      this.messageConfirmButton = this.$t('button.confirm');
      this.confirmDialog = true;
    },
    validaCNPJ(val) {
      if (val.length == 18) {
        var cnpj = val.trim();

        cnpj = cnpj.replace(/\./g, "");
        cnpj = cnpj.replace("-", "");
        cnpj = cnpj.replace("/", "");
        cnpj = cnpj.split("");

        var v1 = 0;
        var v2 = 0;
        var i = 0;
        var p1 = 0;
        var p2 = 0;
        var aux = false;

        for (i = 1; cnpj.length > i; i++) {
          if (cnpj[i - 1] != cnpj[i]) {
            aux = true;
          }
        }

        if (aux == false) {
          return false;
        }

        for (i = 0, p1 = 5, p2 = 13; cnpj.length - 2 > i; i++, p1--, p2--) {
          if (p1 >= 2) {
            v1 += cnpj[i] * p1;
          } else {
            v1 += cnpj[i] * p2;
          }
        }

        v1 = v1 % 11;

        if (v1 < 2) {
          v1 = 0;
        } else {
          v1 = 11 - v1;
        }

        if (v1 != cnpj[12]) {
          return false;
        }

        for (i = 0, p1 = 6, p2 = 14; cnpj.length - 1 > i; i++, p1--, p2--) {
          if (p1 >= 2) {
            v2 += cnpj[i] * p1;
          } else {
            v2 += cnpj[i] * p2;
          }
        }

        v2 = v2 % 11;

        if (v2 < 2) {
          v2 = 0;
        } else {
          v2 = 11 - v2;
        }

        if (v2 != cnpj[13]) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deleteEmpresa, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    close() {
      this.dialog = false;
      this.locaisDoEmpresa = [];
      this.locaisSelecionados = [];
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    loadLocaisDoEmpresa(idEmpresa) {
      if (!idEmpresa) {
        this.locaisDoEmpresa = [];
        this.locaisSelecionados = [];
        return;
      }
      apiController.request(apiController.endpoints.getLocaisporempresa, {
        params: { id: idEmpresa },
        silent: true,
        onSuccess: (response) => {
          this.locaisDoEmpresa = response.data || [];
          this.locaisSelecionados = [...this.locaisDoEmpresa];
        },
        onError: () => {
          this.locaisDoEmpresa = [];
          this.locaisSelecionados = [];
        },
      });
    },
    removeLocal(index) {
      this.locaisSelecionados.splice(index, 1);
    },
    getNomeLocal(item) {
      if (typeof item === 'string') return item;
      if (item && typeof item === 'object' && item.nome_local) return item.nome_local;
      const found = this.locaisDoEmpresa.find((l) => l.id_local === item);
      return found ? found.nome_local : (item != null ? String(item) : '');
    },
    saveLocaisEmpresa(idEmpresa) {
      const selectedIds = this.locaisSelecionados
        .filter((x) => typeof x !== 'string')
        .map((x) => (typeof x === 'object' && x && x.id_local != null ? x.id_local : x));
      const toInsert = this.locaisSelecionados.filter((x) => typeof x === 'string' || (x && typeof x === 'object' && x.id_local == null));
      const toDelete = this.locaisDoEmpresa.filter((l) => !selectedIds.includes(l.id_local));
      const deletePromises = toDelete.map((l) =>
        apiController.request(apiController.endpoints.deleteLocalempresa, {
          params: { id: l.id_local },
          silent: true,
        })
      );
      const insertPromises = toInsert.map((nome) =>
        apiController.request(apiController.endpoints.insertLocalempresa, {
          data: {
            id_empresa: idEmpresa,
            nome_local: typeof nome === 'string' ? nome : (nome && nome.nome_local) || '',
          },
          silent: true,
        })
      );
      return Promise.all([...deletePromises, ...insertPromises]);
    },
    async save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        if (this.editedIndex == -1) {
          this.operacao = 0;
          let response;
          try {
            response = await apiController.request(apiController.endpoints.insertEmpresa, {
              data: this.editedItem,
              silent: true,
            });
          } catch (e) {
            EventBus.$emit('show-error', { error: e });
            return;
          }
          if (response.data.erro) {
            this.updateTable(true);
            return;
          }
          try {
            const r = await apiController.request(apiController.endpoints.getEmpresaporrazao, {
              query: { razao: this.editedItem.razao_social },
              silent: true,
            });
            const empresa = r.data;
            const idEmpresa = empresa && empresa.id_empresa;
            if (idEmpresa && this.locaisSelecionados.length) {
              await this.saveLocaisEmpresa(idEmpresa);
            }
            this.updateTable(false);
            this.populaMatriz();
          } catch (e) {
            EventBus.$emit('show-error', { error: e });
            this.updateTable(false);
            this.populaMatriz();
          }
        } else {
          this.operacao = 1;
          let response;
          try {
            response = await apiController.request(apiController.endpoints.updateEmpresa, {
              data: this.editedItem,
              silent: true,
            });
          } catch (e) {
            EventBus.$emit('show-error', { error: e });
            return;
          }
          if (response.data.erro) {
            this.updateTable(true);
            return;
          }
          const idEmpresa = this.editedItem.id_empresa;
          if (idEmpresa) {
            try {
              await this.saveLocaisEmpresa(idEmpresa);
              this.updateTable(false);
              this.populaMatriz();
            } catch (e) {
              EventBus.$emit('show-error', { error: e });
              this.updateTable(false);
              this.populaMatriz();
            }
          } else {
            this.updateTable(false);
            this.populaMatriz();
          }
        }
      }
    },
    saveBulk(result) {
      apiController.request(apiController.endpoints.upsertEmpresasbulk, {
        data: result,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    updateTable(status) {
      if (status) {
        if (this.operacao == 0) {
          EventBus.$emit('show-alert', { mensagem: this.$t('updateTable.error.insert'), tipo: 'error' });
        } else {
          if (this.operacao == 1) {
            EventBus.$emit('show-alert', { mensagem: this.$t('updateTable.error.update'), tipo: 'error' });
          } else {
            EventBus.$emit('show-alert', { mensagem: this.$t('updateTable.error.delete'), tipo: 'error' });
          }
        }
      } else {
        if (this.operacao == 0) {
          EventBus.$emit('show-alert', { mensagem: this.$t('updateTable.success.insert'), tipo: 'success' });
        } else {
          if (this.operacao == 1) {
            EventBus.$emit('show-alert', { mensagem: this.$t('updateTable.success.update'), tipo: 'success' });
          } else {
            EventBus.$emit('show-alert', { mensagem: this.$t('updateTable.success.delete'), tipo: 'success' });
          }
        }
      }
      this.close();
      this.initialize();
    },
  },
};
</script>
